import { useWorkspace } from "@/workspaces/WorkspaceContext"

type FeatureReason = "plan" | "setting"

export function useFeatureFlag(flag: string): { enabled: boolean; reason?: FeatureReason } {
  const { subscription, workspace } = useWorkspace()

  if (flag === "meetings") {
    const planAllows = subscription.plan.features?.meetings === true
    const settingOn = workspace.settings?.meetings_enabled === true
    if (!planAllows) return { enabled: false, reason: "plan" }
    if (!settingOn) return { enabled: false, reason: "setting" }
    return { enabled: true }
  }

  return { enabled: true }
}

export function useMeetingsGate() {
  const { subscription, workspace } = useWorkspace()
  const planAllows = subscription.plan.features?.meetings === true
  const settingOn = workspace.settings?.meetings_enabled === true
  return { planAllows, settingOn, enabled: planAllows && settingOn }
}
